<template>
  <el-container direction="vertical">
    <el-header height="80px" class="row-head">
      <div>
        <el-row  type="flex">
          <el-col :span="2">
            <div></div>
            <el-image class="image-head" src="static/img/logo.png"/>
          </el-col>
          <el-col :span="6">
            <div class="div-head-label">
              <label class="label-head-top">慧&nbsp;源&nbsp;创&nbsp;新&nbsp;科&nbsp;技&nbsp;有&nbsp;限&nbsp;公&nbsp;司</label>
            </div>
            <div >
              <label class="label-head-bottom">Huiyuan&nbsp;Innovation&Technology&nbsp;Co.,Ltd</label>
            </div>
          </el-col>
          <el-col :span="16" >
            <div class="el-menu-head">
              <el-menu :default-active="activeIndex" style=" height: 80px;border: 0;" mode="horizontal"
                       backgroundColor="#333333"
                       @select="handleSelect" text-color="white"
                        active-text-color="black">
                <el-menu-item class="el-menu-item-head" style="height: 80px;border: 0;" index="1">首页</el-menu-item>
                <el-menu-item class="el-menu-item-head" style="height: 80px;border: 0;" index="2">关于我们</el-menu-item>
                <el-menu-item class="el-menu-item-head" style="height: 80px;border: 0;" index="3">企业动态</el-menu-item>
                <el-menu-item class="el-menu-item-head" style="height: 80px;border: 0;" index="4">产品中心</el-menu-item>
                <el-menu-item class="el-menu-item-head" style="height: 80px;border: 0;" index="5">人才招聘</el-menu-item>
                <el-menu-item class="el-menu-item-head" style="height: 80px;border: 0;" index="6">联系我们</el-menu-item>
              </el-menu>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-header>
    <el-main class="main">
      <keep-alive >
      <component :is="currentPageNames"/>
    </keep-alive>
    </el-main>
    <el-footer class="div-footer" height="240px">
      <div class="div-bottom" v-show="showReturnTop">
        <img src="static/img/icon08_top.png" alt=""
                  class="img-bottom" @click="jumpScollTop()"/>
      </div>
      <div class="div-bottom2">
        <div class="img-footer">
          <img style="width:80px;height: 40px " :src="bottomSrc"  alt=""  @click="jumpScollTop"/>
        </div>
        <div>
          <el-row type="flex">
            <el-col :span="6">
              <div></div>
            </el-col>
            <el-col :span="6">
              <div class="div-footer-left">
                <div>
                  <label class="label-footer-1">联 系 我 们</label>
                </div>
                <div class="div-footer-3">
                  <label class="label-footer-2">CONTACT US</label>
                </div>
                <div>
                  <label class="label-footer-3">慧源创新科技有限公司(总部)</label>
                </div>
                <div>
                  <label class="label-footer-3">服务热线:0755-23720412</label>
                </div>
                <div>
                  <label class="label-footer-3">商务合作:李先生 15818626699</label>
                </div>
                <div>
                  <label class="label-footer-3">地址:深圳市宝安区美生创谷科技园春谷401A区</label>
                </div>
              </div>
            </el-col>
            <el-col :span="6" class="div-footer-right">
              <div class="div-footer-right-top">
              </div>
              <div>
<!--                <el-button round class="button-footer-4"  @click.native="jumpSystem">慧&nbsp;源&nbsp;后&nbsp;台&nbsp;管&nbsp;理&nbsp;系&nbsp;统</el-button>-->
<!--                <br>-->
                <label class="label-footer-4">版权所有:慧源创新科技有限公司&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
              </div>
              <div >
                <el-link href="https://beian.miit.gov.cn" target="_blank" class="label-footer-5" :underline="false">粤ICP备18095928号</el-link>
              </div>
              <div class="div-footer-right-bottom">
              </div>
            </el-col>
            <el-col :span="6">
              <div></div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-footer>
  </el-container>
</template>

<script>
import AboutUs from './AboutUs.vue'
import ContactUs from './ContactUs.vue'
import Dynamic from './Dynamic.vue'
import Home from './Home.vue'
import Product from './Product.vue'
import SignboardUs from './SignboardUs.vue'

export default {
  name: 'HelloWorld',
  data () {
    return {
      showReturnTop: true,
      isActive: 1,
      activeIndex: '1',
      currentPageNames: 'Home',
      bottomSrc: 'static/img/icon08_bottom.png'
    }
  },
  components: {
    Home,
    AboutUs,
    Dynamic,
    Product,
    SignboardUs,
    ContactUs
  },
  methods: {
    pageNames () {
      this.bottomSrc = 'static/img/icon08_bottom2.png'
      this.showReturnTop = false
      switch (this.isActive) {
        case 1:
          this.showReturnTop = true
          this.bottomSrc = 'static/img/icon08_bottom.png'
          this.currentPageNames = 'Home'
          break
        case 2:
          this.currentPageNames = 'AboutUs'
          break
        case 3:
          this.currentPageNames = 'Dynamic'
          break
        case 4:
          this.currentPageNames = 'Product'
          break
        case 5:
          this.currentPageNames = 'SignboardUs'
          break
        case 6:
          this.currentPageNames = 'ContactUs'
          break
      }
    },
    handleSelect (key, keyPath) {
      if (key !== this.activeIndex) {
        this.activeIndex = key
        this.isActive = parseInt(key)
        this.pageNames()
        this.jumpToTop()
      }
      // let index = parseInt(key)
    },
    jumpSystem () {
      window.open('http://app.hy-chip.com/hyChip3/wLogin/login')
    },
    jumpScollTop () {
      var timer = setInterval(function () {
        let osTop = document.documentElement.scrollTop || document.body.scrollTop
        let ispeed = Math.floor(-osTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed
        this.isTop = true
        if (osTop < 5) {
          clearInterval(timer)
        }
      }, 20)
    },
    jumpToTop () {
      document.documentElement.scrollTop = document.body.scrollTop = 0
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.row-head{
  background: #333333;
  margin: 0;
  padding: 0;
  position: fixed;/*固定位置*/
  top:0;
  width: 100%;
  z-index:1000;/*设置优先级显示，保证不会被覆盖*/
}
.main{
  height: 100%;
  padding: 0;
  min-height: 630px;
  margin-top: 80px;
  margin-bottom: 0;
  border: 0;
}

.image-head{
  float: right;
  padding-right: 20px;
  margin-top: 20px;
}
.el-menu-item {
  border-bottom: 0 none;
}
.el-menu-item.is-active {
  border-bottom: 0 none;
  background-color: white !important;
}
.el-menu-item.isChecked span{
  border-bottom: 0 none;
}
.div-head-label{
  /*flex 布局*/
  display: flex;
}
.label-head-top{
  margin-top: 18px;
  font-size: large;
  color: white;
  font-weight: bold;
}
.label-head-bottom{
  font-size: xx-small;
  color: #F0F0F0;
  padding: 0;
}
.el-menu-head{
  height: 80px;
  border: 0;
}

.el-menu-item-head{
  width: 120px;
  text-align: center;
  padding: 10px;
  font-size: 15px;
  font-weight: bold;
}
.el-menu-item-head:hover{
  background: white;
}

.img-footer{
  text-align: center;
}
.div-footer-left{
  text-align: left;
}
.label-footer-1{
  color: white;
  font-size: x-large;
}
.div-footer-3{
  margin-bottom: 16px;
}
.label-footer-2{
  color: white;
  font-size: medium;
}
.label-footer-3{
  color: #CACACA !important;
  font-size: smaller;
}
.button-footer-4{
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 6px;
  padding-bottom: 6px;
  font-size: medium;
  color: white;
  background-color: #555555;
  border-color: #555555;
  margin-bottom: 5px;
}
.button-footer-4:hover {
  color: #555555;
  background-color: white;
  border-color: white;
}
.label-footer-4{
  color: #CACACA !important;
  font-size: 14px;
}
.label-footer-5{
  color: #CACACA !important;
  font-size: 14px;
}
.label-footer-5:hover{
  color: white !important;
  font-size: 14px;
}
.div-footer{
  margin: 0;
  padding: 0;
  width: 100%;
}
.div-footer-right-top{
  height: 44%;
}
.div-footer-right-bottom{
  height: 2%;
}
.div-footer-right{
  text-align: left;
}
.div-bottom{
  text-align: center;
  align-content: end;
  border: 0;
  background: #F4F4F4;
  height: 40px;
}
.div-bottom2{
  background: #444444;
  height: 100%;
}
.img-bottom{
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/Main.vue